import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Row, Col, Form, Button, Container, Card } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { MdArrowBack, MdSave } from "react-icons/md";

const AddInventoryCategory = () => {
  const [editId, setEditId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};

  const [form, setForm] = useState({
    category_name: "",
    description: "",
  });

  useEffect(() => {
    if (location.state?.categoryData) {
      const categoryData = location.state.categoryData;
      setForm(categoryData);
      setEditId(categoryData.category_id);
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      ...form,
      school_id: userObj.school_id,
      createdby: userObj.user_id,
      lastmodifiedby: userObj.user_id,
      is_active: editId !== null ? form.is_active : "A",
      action: editId !== null ? "UPDATE" : "CREATE"
    };

    if (editId !== null) {
      formData.category_id = editId;
    }

    try {
      await axios.post(baseUrl + "/inventorycategory/", formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setForm({
        category_name: "",
        description: "",
      });
      if (editId !== null) {
        toast.success("Record Updated Successfully");
        setTimeout(() => navigate("/inventorycategory"), 1500);
      } else {
        toast.success("Record Added Successfully");
        setTimeout(() => navigate("/inventorycategory"), 1500);
      }
    } catch (error) {
      console.error("Error submitting data:", error.response?.data || error.message);
      const rawMsg = error.response?.data?.message || error.response?.data?.error || "Unexpected error occurred";
      const cleanMsg = typeof rawMsg === "string" ? rawMsg.split(/CONTEXT:|\\n/i)[0].trim() : rawMsg;
      toast.error(cleanMsg);
    }
  };

  return (
    <div className="pageBody">
      <ToastContainer />
      <Container fluid>
        <div className="">
          <Card>
            <Card.Body>
              <form className="" onSubmit={handleSubmit}>
                <div className="">
                  <Row>
                    <Col xs={12}>
                      <h6 className="commonSectionTitle">Category Details</h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6} lg={4} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>Category Name <span className="requiredStar">*</span></Form.Label>
                          <Form.Control
                            required
                            type="text"
                            name="category_name"
                            value={form.category_name}
                            placeholder="Enter Category Name"
                            maxLength={30}
                            onChange={handleInputChange}
                          />
                          <Form.Control.Feedback>Required</Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={6} lg={4} xxl={3}>
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={1}
                            name="description"
                            value={form.description}
                            placeholder="Enter Description"
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <Button
                      type="button"
                      variant="primary"
                      className="btn-info clearBtn"
                      onClick={() => setForm({
                        category_name: "",
                        description: "",
                      })}
                    >
                      Reset
                    </Button>
                  </div>
                  <div>
                    <Button
                      type="button"
                      variant="primary"
                      className="btn-danger secondaryBtn me-2"
                      onClick={() => navigate("/inventorycategory")}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-success primaryBtn"
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default AddInventoryCategory;
